import {
  Component,
  Input,
  OnInit,
  OnChanges,
  ViewEncapsulation,
  SimpleChanges,
} from "@angular/core";
import { faInfoCircle, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { Store } from "@ngrx/store";
import {
  VAIconRegistryService,
  infoCircle,
  plus,
} from "@va/core-library/icons";
import { Subscription } from "rxjs";
import { AppService } from "src/app/app.service";
import { CustomConsensusService } from "src/app/custom-consensus/custom-consensus.service";
import { RightPanelService } from "src/app/right-panel/right-panel.service";
import { GetSourceMeta } from "src/app/store/actions/right-panel-actions";
import { Dictionary } from "src/app/store/models/common_types";
import { PageParams } from "src/app/store/models/navigation-settings.model";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { environment } from "src/environments/environment";

declare function gridRefresh(eventTarget, event);
declare function OnDefaultSetting(sectionName);
declare function RepresentSource(type);

@Component({
  selector: "app-source",
  templateUrl: "./right-panel-source.component.html",
  styleUrls: ["./right-panel-source.component.scss"],
  host: { class: "source-panel-container" },
  encapsulation: ViewEncapsulation.None,
})
export class RightPanelSourceComponent implements OnInit, OnChanges {
  @Input() sourcePanelData: Dictionary<any>;
  brokersList: Array<any>;
  allSourceIds: Set<number>;
  showClear: boolean;
  showOnlyCurrent: boolean;
  sortColumnName = "modeldatetime";
  sortOrder = "desc";
  forecastFocusList: Array<string>;
  historicalFocusList: Array<string>;
  checkAll = false;
  indeterminate = false;
  originalSourceObj: Dictionary<any>;
  selectedSourceForStore: Array<any> = [];
  tempObj: Dictionary<any>;
  focusedForecastSource: string;
  focusedActualSource: string;
  anyValueUpdated: boolean;
  ticker: string;
  pageName = "";
  cut: string = null;
  source: string = null;
  disabled = true;
  showPanel = true;
  ccVisible = false;
  customBrokerList: Array<any> = [];
  lastFilingsDate = null;
  filingsCheck = false;
  vaActualsCheck = false;
  excl_non_entitled_brokers = false;
  unentitledAllBrokerListForToolTip = [];
  rowSelected = false;
  columnSelected = false;
  consensusCheck = false;
  customConsensusCheck = false;
  consensusPlusCheck = false;
  sourcePlacement = "column";
  droppedBrokers: Array<any> = [];
  restrictedBrokers: Array<any> = [];
  isConsensusPlusUser = false;
  globalSettingsSub: Subscription;
  navigationSettingSub: Subscription;
  rightPanelSourcemetaSub: Subscription;
  ccState = false;
  isFirstLoad = true;
  assets = environment.assetUrl;
  sortKeys: { [key: string]: string | null } = {
    modeldatetime: null,
    name: null,
  };
  deleteGridHistoryType = {
    surprise: 4,
    revisions: 3,
  };
  faInfoCircle = faInfoCircle;
  faPlus = faPlus;

  exclNonEntitled = [];
  nonEntitled = [];

  constructor(
    private appService: AppService,
    private service: RightPanelService,
    private store: Store<AppState>,
    private ccService: CustomConsensusService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([infoCircle, plus]);
  }

  ngOnInit() {
    this.navigationSettingSub = this.store
      .select(stateGetter("navigationSettings", "pageParams"))
      .subscribe((params: PageParams) => {
        if (params) {
          this.ticker = params.ticker;
          this.pageName = params.pageName;
          this.cut = params.cut;
        }
      });

    this.rightPanelSourcemetaSub = this.store
      .select(stateGetter("rightPanel", "sourceMeta", "appliedGridFilters"))
      .subscribe((appliedGridFilters) => {
        // grid filter or source filter in either of the case clear should be visible
        this.showClear = appliedGridFilters || this.showClear;
      });

    this.globalSettingsSub = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        if (data) {
          this.isConsensusPlusUser = window.isConsensusPlusUser =
            data.isConsensusPlusUser;
        }
      });

    window.addEventListener("MEDataSet", (rpObj: any) => {
      if (rpObj.detail.section === "ccUpdated") {
        const panelData = rpObj.detail.data.panels.find(
          (panel) => panel.name.toLowerCase() === "sources",
        );
        this.setRightPanelData(panelData, true);
        this.onApplyClick(rpObj.detail.clickEvent);
        this.focusedForecastSource = "Custom";
        // this.tempObj["default-future"] = 'Custom';
        window.MEData.panels[1].values
          .find((v) => v.name === "computed")
          .values.find((s) => s.name === "Consensus").focus = false;
        window.MEData.panels[1].values
          .find((v) => v.name === "computed")
          .values.find((s) => s.name === "Custom").focus = true;
        window.gSource =
          window.gSourceFuture =
          window.gFocusSource =
          window.gSourceFocus =
            "Custom";
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.sourcePanelData !== undefined &&
      changes.sourcePanelData.currentValue !== undefined
    ) {
      this.setRightPanelData(changes.sourcePanelData.currentValue);
    }
  }

  setRightPanelData(panelData, ccUpdated?: boolean) {
    // this.originalSourceObj = { ...panelData };
    // this.tempObj = { ...panelData };
    this.originalSourceObj = this.appService.getDuplicateObject(panelData);
    this.tempObj = this.appService.getDuplicateObject(panelData);

    if (ccUpdated) {
      this.setSelectionOnComputedSource("Consensus+", this.consensusPlusCheck);
      this.setSelectionOnComputedSource("Consensus", this.consensusCheck);
    }

    this.disabled = true;
    this.focusedForecastSource =
      panelData["focus"] || panelData["default-future"];
    this.showClear = panelData["show_clear"] || panelData["clear_dimension"];
    this.sortColumnName = panelData["sort_column"];
    this.sortOrder = panelData["sort_order"] === "asc" ? "ascend" : "descend";
    this.showOnlyCurrent = panelData["show_only_current"];
    // this.rowSelected = panelData['type'] === 'row';
    // this.columnSelected = panelData['type'] === 'column';
    this.sourcePlacement = panelData["type"];
    this.focusedActualSource = panelData["actual-default"] || null;
    this.droppedBrokers = panelData["dropped_broker"] || [];
    this.restrictedBrokers = panelData["restricted_broker"] || [];
    this.brokersList = this.getAllBrokerList(null);
    this.setSelectedSourceForStore();
    this.sort(this.sortOrder, this.sortColumnName);
    this.forecastFocusList = this.getFocusedSourceList("forecast");
    this.onShowCurrentSwitch(this.showOnlyCurrent, null);
    // Adding to check if we need to show the Unentitled Info Icon
    this.exclNonEntitled = panelData["excl_non_entitled"] || [];
    this.nonEntitled = panelData["non_entitled"] || [];
    // this.excl_non_entitled_brokers =
    //   panelData["excl_non_entitled_brokers"] || false;
    this.historicalFocusList = this.getFocusedSourceList("actuals");
    //Adding this here till we find a better place where the code is called only once and has the required panelData
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      if (
        panelData["excl_non_entitled_brokers"] &&
        panelData["excl_non_entitled_brokers"].length > 0
      ) {
        this.unentitledAllBrokerListForToolTip =
          this.unentitledAllBrokerListForToolTip.concat(
            panelData["excl_non_entitled_brokers"],
          );
      }
      if (
        panelData["non_entitled_brokers"] &&
        panelData["non_entitled_brokers"].length > 0
      ) {
        this.unentitledAllBrokerListForToolTip =
          this.unentitledAllBrokerListForToolTip.concat(
            panelData["non_entitled_brokers"],
          );
      }
    }
    this.onUpdateFocus(this.focusedForecastSource, "forecast", null);
    this.setCcState();
  }

  /**
   *
   * @param evt will be used as event parameter when calling loguseraction
   */
  getAllBrokerList(evt?: any) {
    let brokerList: any = [];
    const currentContext = this; // eslint-disable-line
    if (this.tempObj.values === undefined) {
      brokerList = this.tempObj["brokers"].filter(
        (obj) => obj.name.toLowerCase() !== "filings",
      );
    } else {
      const brokerObj = this.tempObj.values[2].values;
      const historicalObj = this.tempObj.values[1];
      const computedObj = this.tempObj.values[0];
      brokerList = brokerObj.filter(
        (obj) => obj.name.toLowerCase() !== "filings",
      );
      // this.filingsCheck = historicalObj.values[1].selected;
      const filingsObj = historicalObj.values.find(
        (obj) => obj.name === "Filings",
      );
      this.filingsCheck = filingsObj && filingsObj.selected;
      this.lastFilingsDate = filingsObj && filingsObj.modeldate;

      // this.vaActualsCheck = historicalObj.values[0].selected;
      const vaActualsObj = historicalObj.values.find(
        (obj) => obj.name === "VA Actuals",
      );
      this.vaActualsCheck = vaActualsObj && vaActualsObj.selected;

      const consensusObj = computedObj.values.find(
        (obj) => obj.name === "Consensus",
      );
      const conPlusObj = computedObj.values.find(
        (obj) => obj.name === "Consensus+",
      );
      const custConObj = computedObj.values.find(
        (obj) => obj.name === "Custom",
      );
      if (!this.isConsensusPlusUser) {
        this.consensusCheck = consensusObj && consensusObj.selected;
        this.customConsensusCheck = custConObj && custConObj.selected;
      } else {
        this.consensusPlusCheck = conPlusObj && conPlusObj.selected;
        this.consensusCheck = consensusObj && consensusObj.selected;
        this.customConsensusCheck = custConObj && custConObj.selected;
      }

      brokerList.forEach(function (obj) {
        const feature = `OPTIONS_SOURCES_${obj.name.toUpperCase()}`;
        const extras = {
          VALUE: obj.selected ? "ON" : "OFF",
          URL: window.location.href,
          UTCTIME: currentContext.appService.getCurrentUTCTime(),
        };
        currentContext.logUserAction(feature, extras, evt && obj.selected);
      });
    }
    this.allSourceIds = brokerList.map((brokerObj) => brokerObj.sourceid);
    this.customBrokerList = brokerList;
    return brokerList;
  }

  resetPanelData() {
    this.focusedForecastSource = "";
    this.brokersList = [];
    this.showClear = false;
    this.showOnlyCurrent = false;
    this.indeterminate = false;
    this.checkAll = false;
    this.sourcePlacement = "column";
    this.tempObj = this.appService.getDuplicateObject(this.originalSourceObj);
  }

  onShowCurrentSwitch(isSwitchedOn, evt?) {
    this.showOnlyCurrent = isSwitchedOn ? true : false;
    this.brokersList = isSwitchedOn
      ? this.removeExcludedFromBrokerList(evt)
      : this.getAllBrokerList(evt);
    this.tempObj["show_only_current"] = isSwitchedOn;
    this.onValueUpdated();
    this.refreshCheckedStatus();
    this.sort(this.sortOrder, this.sortColumnName);
  }

  removeExcludedFromBrokerList(evt) {
    let filteredBrokerList: any = [];
    const currentContext = this; // eslint-disable-line
    if (this.originalSourceObj.values === undefined) {
      filteredBrokerList = this.originalSourceObj["brokers"].filter(
        (obj) => obj.name.toLowerCase() !== "filings" && obj.excluded === false,
      );
    } else {
      const brokerObj = this.tempObj.values.filter(
        (obj) => obj.name.toLowerCase() === "brokers",
      );
      filteredBrokerList = brokerObj[0].values.filter(
        (obj) => obj.name.toLowerCase() !== "filings" && obj.excluded === false,
      );

      filteredBrokerList.forEach(function (obj) {
        const feature = `OPTIONS_SOURCES_${obj.name.toUpperCase()}`;
        const extras = {
          VALUE: obj.selected ? "ON" : "OFF",
          URL: window.location.href,
          UTCTIME: currentContext.appService.getCurrentUTCTime(),
        };
        currentContext.logUserAction(feature, extras, evt && obj.selected);
      });
    }
    return filteredBrokerList;
  }

  getFocusedSourceList(type) {
    let focusedSourceList: any = [];
    if (this.originalSourceObj.values === undefined) {
      // for surprise and revision source obj
      focusedSourceList = this.originalSourceObj["brokers"]
        .filter(
          (obj) =>
            obj.name.toLowerCase() !== "filings" &&
            !this.droppedBrokers.includes(obj.sourceid) &&
            !this.restrictedBrokers.includes(obj.sourceid) &&
            !obj.excluded,
        )
        .map((broker) => broker.name);
      focusedSourceList.unshift("Consensus");
    } else {
      // for mex source obj
      const brokerObj = this.tempObj.values.filter(
        (obj) => obj.name.toLowerCase() === "brokers",
      );
      focusedSourceList = brokerObj[0].values
        .filter(
          (obj) =>
            obj.name.toLowerCase() !== "filings" &&
            !this.droppedBrokers.includes(obj.sourceid) &&
            !this.restrictedBrokers.includes(obj.sourceid),
        )
        .map((broker) => broker.name);
      focusedSourceList.unshift("Custom");
      focusedSourceList.unshift("Consensus");
      if (this.isConsensusPlusUser && this.cut) {
        focusedSourceList.unshift("Consensus+");
        window.gFocusSource = this.focusedForecastSource;
        window.gSourceFuture = this.focusedForecastSource;
      }
      if (type === "actuals") {
        focusedSourceList.unshift("VA Actuals");
        focusedSourceList.unshift("Filings");
      }
    }
    return focusedSourceList;
  }

  onRowChecked(id: number, checkAll: boolean): void {
    this.updateCheckedSet(id, checkAll);
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (this.tempObj.values === undefined) {
      const updatedObj = this.tempObj["brokers"].map((obj) => {
        return { ...obj };
      });
      this.brokersList.find((obj) => obj.sourceid === id).selected = checked;
      updatedObj.find((obj) => obj.sourceid === id).selected = checked;
      this.tempObj["brokers"] = updatedObj;
    } else {
      const brokerObj = this.tempObj.values[2].values;
      const updatedObj = brokerObj.map((obj) => {
        return { ...obj };
      });
      this.brokersList.find((obj) => obj.sourceid === id).selected = checked;
      updatedObj.find((obj) => obj.sourceid === id).selected = checked;
      this.tempObj.values[2].values = updatedObj;
    }
    this.onValueUpdated();
    const sourceName = this.brokersList.find((obj) => obj.sourceid === id).name;
    const feature = `OPTIONS_SOURCES_${sourceName.toUpperCase()}`;
    const extras = {
      VALUE: checked ? "ON" : "OFF",
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras);
  }

  onCheckAll(value: boolean): void {
    const currentContext = this; // eslint-disable-line
    this.brokersList = this.brokersList.map(function (obj) {
      const prevSelectionState = obj.selected;
      obj = {
        ...obj,
        selected: obj.focus ? true : value,
      };

      const feature = `OPTIONS_SOURCES_${obj.name.toUpperCase()}`;
      const extras = {
        VALUE: obj.selected ? "ON" : "OFF",
        URL: window.location.href,
        UTCTIME: currentContext.appService.getCurrentUTCTime(),
      };
      currentContext.logUserAction(
        feature,
        extras,
        prevSelectionState !== obj.selected,
      );
      return obj;
    });
    //to differentiate revision,surprise / mex source object
    if (this.tempObj.values === undefined) {
      const updatedObj = this.tempObj["brokers"].map((obj) => {
        return { ...obj };
      });
      updatedObj.forEach(function (obj) {
        obj.selected = obj.focus ? true : value;
      });
      this.tempObj["brokers"] = updatedObj;
    } else {
      const brokerObj = this.tempObj.values[2].values;
      const updatedObj = brokerObj.map((obj) => {
        return { ...obj };
      });
      updatedObj.forEach(function (obj) {
        obj.selected = obj.focus ? true : value;
      });
      this.tempObj.values[2].values = updatedObj;
    }
    this.onValueUpdated();
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checkAll = this.brokersList.every((obj) => obj.selected);
    this.indeterminate =
      this.brokersList.some((obj) => obj.selected) && !this.checkAll;
  }

  //type can be 'actual' or 'forecast'
  onUpdateFocus(focusedSource, type, evt?) {
    if (this.tempObj.values !== undefined) {
      const panelIdx = this.getIndexForPanel(window.MEData.panels);
      if (type === "forecast") {
        this.focusedForecastSource = focusedSource;
        this.tempObj["default-future"] = focusedSource;
        window.MEData.panels[panelIdx]["default-future"] = focusedSource;

        this.resetSourcesOnSection("computed", "focus", false);
        this.resetSourcesOnSection("Brokers", "focus", false);
        this.setFocusInValues(focusedSource, true);

        this.customConsensusCheck =
          ["Custom Consensus", "Custom"].includes(focusedSource) ||
          this.focusedActualSource === "Custom"
            ? true
            : this.customConsensusCheck;

        this.consensusCheck =
          ["Consensus"].includes(focusedSource) ||
          this.focusedActualSource === "Consensus"
            ? true
            : this.consensusCheck;

        this.consensusPlusCheck =
          ["Consensus+"].includes(focusedSource) ||
          this.focusedActualSource === "Consensus+"
            ? true
            : this.consensusPlusCheck;
      } else {
        this.focusedActualSource = focusedSource;
        this.tempObj["actual-default"] = focusedSource;
        window.MEData.panels[panelIdx]["actual-default"] = focusedSource;

        this.resetSourcesOnSection("computed", "historical_focus", false);
        //@todo need to refactore as discussed with @nilesh , focus for actuals is driven by actual-default and not historica_focus in broker
        // this.resetSourcesOnSection("Brokers", "historical_focus", false);
        this.resetSourcesOnSection("Historicals", "historical_focus", false);
        this.setHistoricalFocusInValues(focusedSource, true);

        this.customConsensusCheck =
          ["Custom Consensus", "Custom"].includes(focusedSource) ||
          this.focusedForecastSource === "Custom"
            ? true
            : this.customConsensusCheck;

        this.consensusCheck =
          ["Consensus"].includes(focusedSource) ||
          this.focusedForecastSource === "Consensus"
            ? true
            : this.consensusCheck;

        this.consensusPlusCheck =
          ["Consensus+"].includes(focusedSource) ||
          this.focusedForecastSource === "Consensus+"
            ? true
            : this.consensusPlusCheck;
      }
    } else {
      this.focusedForecastSource = focusedSource;
      this.tempObj["focus"] = focusedSource;
      const focusIndex = this.brokersList.findIndex((x) => x.focus);
      if (focusIndex >= 0) {
        this.brokersList[focusIndex].focus = false;
      }
    }

    if (
      !["Consensus", "Custom", "Consensus+", "Filings", "VA Actuals"].includes(
        focusedSource,
      )
    ) {
      this.brokersList = this.brokersList.map((brokerObj) => {
        if (brokerObj.focus === true) {
          brokerObj.focus = false;
        }
        return brokerObj;
      });

      this.brokersList = this.brokersList.map((brokerData) => {
        const brokerObj = { ...brokerData };
        if (
          brokerObj.name === this.focusedForecastSource ||
          brokerObj.name === this.focusedActualSource
        ) {
          brokerObj.focus = true;
        }
        return brokerObj;
      });

      this.brokersList.find(
        (brokerObj) => brokerObj.name === focusedSource,
      ).selected = true;
    } else {
      // Adding this section to ensure the previously selected broker is not disabled when the user selects
      // Consensus, VA Actuals, CC or Filings
      this.brokersList = this.brokersList.map((brokerObj) => {
        if (brokerObj.focus === true) {
          brokerObj.focus =
            this.focusedActualSource === brokerObj.name ||
            this.focusedForecastSource === brokerObj.name
              ? true
              : false;
        }
        return brokerObj;
      });
    }

    this.setSelectionOnComputedSource("Consensus+", this.consensusPlusCheck);
    this.setSelectionOnComputedSource("Consensus", this.consensusCheck);
    this.setSelectionOnComputedSource("Custom", this.customConsensusCheck);

    this.onValueUpdated();
    const feature = "OPTIONS_SOURCES_FOCUS";
    const extras = {
      VALUE: focusedSource,
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras, evt);
  }

  setSelectionOnComputedSource(sourceName, selected) {
    if (this.tempObj.values !== undefined) {
      const computedObjIdx = this.tempObj.values.findIndex(
        (obj) => obj.name === "computed",
      );

      const compSourceIdx = this.tempObj.values[
        computedObjIdx
      ].values.findIndex((obj) => obj.name === sourceName);

      if (compSourceIdx > -1) {
        this.tempObj.values[computedObjIdx].values[compSourceIdx].selected =
          selected;
      }
    }
  }

  resetSourcesOnSection(sourceType, keyToReset, valueToSet) {
    const sourceTypeIdx = this.tempObj.values.findIndex(
      (obj) => obj.name === sourceType,
    );
    const sourceVals = this.tempObj.values[sourceTypeIdx].values;
    this.tempObj.values[sourceTypeIdx].values = sourceVals.map((obj) => {
      return { ...obj, [keyToReset]: valueToSet };
    });
  }

  setFocusInValues(sourceName, focus) {
    //try in brokers list
    const brokerObjIdx = this.tempObj.values.findIndex(
      (obj) => obj.name === "Brokers",
    );
    const brokerIdx = this.tempObj.values[brokerObjIdx].values.findIndex(
      (bro) => bro.name === sourceName,
    );
    if (brokerIdx > -1) {
      this.tempObj.values[brokerObjIdx].values[brokerIdx].focus = focus;
      return;
    }

    //try in computed lis
    const computedObjIdx = this.tempObj.values.findIndex(
      (obj) => obj.name === "computed",
    );
    const sourceIdx = this.tempObj.values[computedObjIdx].values.findIndex(
      (s) => s.name === sourceName,
    );
    if (sourceIdx > -1) {
      this.tempObj.values[computedObjIdx].values[sourceIdx].focus = focus;
      return;
    }
  }

  setHistoricalFocusInValues(sourceName, focus) {
    //try in computed list
    const computedObjIdx = this.tempObj.values.findIndex(
      (obj) => obj.name === "computed",
    );
    const sourceIdx = this.tempObj.values[computedObjIdx].values.findIndex(
      (s) => s.name === sourceName,
    );
    if (sourceIdx > -1) {
      this.tempObj.values[computedObjIdx].values[sourceIdx].historical_focus =
        focus;
      return;
    }

    //try in historicals list
    const histObjIdx = this.tempObj.values.findIndex(
      (obj) => obj.name === "Historicals",
    );
    const histIdx = this.tempObj.values[histObjIdx].values.findIndex(
      (s) => s.name === sourceName,
    );
    if (histIdx > -1) {
      this.tempObj.values[histObjIdx].values[histIdx].historical_focus = focus;
      return;
    }
  }

  resetToPreviousState() {
    this.resetPanelData();
    this.setRightPanelData(this.originalSourceObj);
  }

  // reset to previous state
  onCancelClick() {
    // const panelIdx = this.getIndexForPanel(window.MEData.panels);
    // if (this.pageName.toLocaleLowerCase() === "mex") {
    //   this.setRightPanelData(window.MEData.panels[panelIdx]);
    // } else {
    //   this.resetToPreviousState();
    //   this.onValueUpdated();
    // }
    this.resetToPreviousState();
    this.onValueUpdated();
  }

  setSelectedSourceForStore() {
    const selectedSourceForStore = this.brokersList.filter(
      (obj) => obj.name.toLowerCase() !== "filings" && obj.selected,
    );
    //setting back to default state with only selectedSource to avoid multiple meta calls
    this.store.dispatch(
      new GetSourceMeta({
        ticker: undefined,
        isClear: false,
        selectedSources: selectedSourceForStore,
        loaded: true,
      }),
    );
  }

  // API call to save changes and grid refresh
  onApplyClick(evt?: any) {
    let selectedSourceObj: any = {};
    if (this.tempObj.values === undefined) {
      selectedSourceObj = this.tempObj["brokers"].filter(
        (obj) => obj.name.toLowerCase() !== "filings" && obj.selected,
      );
    } else {
      let brokerObj = this.tempObj.values[2].values;
      if (this.sortColumnName === "name") {
        brokerObj = this.sortByBrokers(brokerObj);
      } else if (this.sortColumnName === "modeldatetime") {
        brokerObj = this.sortByDates(brokerObj);
      }

      selectedSourceObj = brokerObj.filter(
        (obj) => obj.name.toLowerCase() !== "filings" && obj.selected,
      );
    }

    selectedSourceObj =
      this.tempObj["show_only_current"] === true
        ? selectedSourceObj.filter((obj) => obj.excluded === false)
        : selectedSourceObj;

    const selectedSourceIds = selectedSourceObj
      .filter((obj) => obj.selected)
      .map((data) => data.sourceid);

    const notSelectedIds = [...this.allSourceIds].filter(
      (id) => selectedSourceIds.indexOf(id) < 0,
    );
    const postObject = {
      company: this.ticker,
      cut: this.pageName === "mex" ? this.cut : null,
      source: this.source,
      jsonData: {
        Sources: {
          type: "column",
          selected: selectedSourceIds,
          not_selected: notSelectedIds,
          focus: this.focusedForecastSource,
          show_only_current: this.showOnlyCurrent,
          sort_column: this.sortColumnName,
          sort_order: this.sortOrder === "descend" ? "desc" : "asc",
        },
      },
    };

    if (this.tempObj.values !== undefined && this.pageName === "mex") {
      const computedSources = this.tempObj.values[0].values
        .filter((obj) => obj.selected === true)
        .map((source) => source.name);
      const historicalSelectedSources = this.tempObj.values[1].values
        .filter((obj) => obj.selected === true)
        .map((source) => source.name);
      const selectedCC = selectedSourceObj
        .filter((obj) => obj.selected_cc === true)
        .map((broker) => broker.name);

      postObject["jsonData"]["Sources"]["type"] = this.sourcePlacement;
      postObject["jsonData"]["Sources"]["historical_selected_sources"] =
        historicalSelectedSources;
      postObject["jsonData"]["Sources"]["historical_focus"] =
        this.focusedActualSource;
      postObject["jsonData"]["Sources"]["computed_sources"] = computedSources;
      postObject["jsonData"]["Custom"] = {
        selected_cc: selectedCC,
        show_only_current_cc: this.tempObj["show_only_current_cc"],
        excl_non_entitled_brokers: this.tempObj["excl_non_entitled_brokers"],
        inc_non_current_brokers: this.tempObj["inc_non_current_brokers"],
      };
    }

    if (this.pageName.toLocaleLowerCase() === "mex") {
      this.tempObj.clear_dimension = true;
      this.sourcePanelData.clear_dimension = true;
      this.updateMEData(this.tempObj);
      window.gSourceActual = this.focusedActualSource;
      window.gFocusSource = this.focusedForecastSource;
      window.gSourceFuture = this.focusedForecastSource;
      if (this.sourcePlacement === "row") {
        window.gSourceActual = window.gFocusSource;
      }

      // updating original source object after apply click.
      this.originalSourceObj = this.appService.getDuplicateObject(this.tempObj);
      this.disabled = true;
      // this.setRightPanelData(window.MEData.panels[1]);
      // this.setRightPanelData(window.MEData.panels[panelIdx]);
      this.setCcState();

      //dispatch event so custom-consensus-modal component knows MEData is modified
      const MEDataSet = new CustomEvent("MEDataSet", {
        detail: { data: window.MEData, section: "Sources", clickEvent: event },
      });
      window.dispatchEvent(MEDataSet);
      gridRefresh(evt.currentTarget, evt);
    } else {
      this.service
        .saveAppliedSettingForSourcePanel(
          this.ticker,
          postObject,
          this.pageName,
        )
        .subscribe((res) => {
          if (res && res["status"] === "success") {
            this.showClear = true;
            this.tempObj["show_clear"] = true;
            this.disabled = true;
            this.store.dispatch(
              new GetSourceMeta({
                ticker: this.ticker,
                isClear: false,
                selectedSources: selectedSourceObj,
                loaded: true,
              }),
            );
          }
        });
    }
  }

  // delete grid panel history and meta call to reset to default state
  onClearClick() {
    const deleteHistoryObj = {
      viewdata: {
        company: this.ticker,
        cut: this.pageName === "mex" ? this.cut : null,
        source: this.source,
        jsonData: {},
        type: this.deleteGridHistoryType[this.pageName],
        dimension: "",
      },
    };

    if (this.pageName === "mex") {
      delete deleteHistoryObj.viewdata.type;
      deleteHistoryObj.viewdata.dimension = "Sources";
    }

    if (this.pageName.toLocaleLowerCase() === "mex") {
      this.removeSourceDimension();
      OnDefaultSetting("Sources");
    } else {
      // grid panel history call
      this.service
        .applyDefaultSetting(deleteHistoryObj)
        .subscribe((response) => {
          if (response && response["status"] === "success") {
            // added for mex
            this.showClear = false;
            // ideally reset whole spurce panel to original object
            this.store.dispatch(
              new GetSourceMeta({
                ticker: this.ticker,
                isClear: true,
                loaded: false,
                appliedGridFilters: false,
              }),
            );
          }
        });
    }
  }

  onValueUpdated() {
    this.disabled = this.appService.compare(
      this.originalSourceObj,
      this.tempObj,
    );
  }

  sort(sortOrder, sortBy) {
    this.sortColumnName = sortBy;
    this.sortOrder = sortOrder;
    for (const key in this.sortKeys) {
      this.sortKeys[key] = key === this.sortColumnName ? sortOrder : null;
    }
    this.brokersList =
      this.sortColumnName === "name"
        ? this.sortByBrokers(this.brokersList)
        : this.sortByDates(this.brokersList);
    this.tempObj["sort_column"] = this.sortColumnName;
    this.tempObj["sort_order"] = this.sortOrder === "ascend" ? "asc" : "desc";
    this.onValueUpdated();
  }

  sortByBrokers(list: Array<any>): Array<any> {
    const isDescend = this.sortOrder === "ascend" ? false : true;
    this.appService.basicSort(
      list,
      [this.sortColumnName.toString().toLowerCase()],
      isDescend,
      (name: string) => {
        return name.toLowerCase();
      },
    );
    return list;
  }

  sortByDates(list: Array<any>): Array<any> {
    const isDescend = this.sortOrder === "ascend" ? false : true;
    const transform = (modeldate: string | null) => {
      if (modeldate === null) {
        return Number.MAX_VALUE;
      }
      return new Date(modeldate).getTime();
    };
    this.appService.basicSort(
      list,
      [this.sortColumnName.toString().toLowerCase()],
      isDescend,
      transform,
    );

    return list;
  }

  showCustomConsensus() {
    this.ccService.showCcModal(true);
  }
  //Gets triggered when the popup closes from within the component
  updateCCVisibility(isPopupVisible: boolean) {
    this.ccVisible = isPopupVisible;
  }

  handleClear = (evt: MouseEvent) => {
    evt.stopImmediatePropagation();
    this.onClearClick();
  };

  handleSourceType(type) {
    RepresentSource(type);
    this.sourcePlacement = type;
    const feature =
      type === "column" ? "OPTIONS_SOURCES_COLUMN" : "OPTIONS_SOURCES_ROW";
    const extras = {};
    this.logUserAction(feature, extras);
    this.tempObj["type"] = type;
    this.onValueUpdated();
  }

  logUserAction(feature, extras, event = {}) {
    this.appService.logUserAction(
      event,
      this.ticker,
      window.MEData.view_code,
      feature,
      extras,
      "",
      "",
    );
  }

  ccChecked(isccChecked) {
    this.customConsensusCheck = isccChecked;
    const feature = "OPTIONS_SOURCES_CUSTOM";
    const extras = {
      VALUE: isccChecked ? "ON" : "OFF",
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras);
    // this.tempObj.values[0].values[1].selected = isccChecked;
    this.setSelectionOnComputedSource("Custom", isccChecked);
    this.onValueUpdated();
  }

  consensusChecked(isConsensusChecked) {
    this.consensusCheck = isConsensusChecked;
    const feature = "OPTIONS_SOURCES_CONSENSUS";
    const extras = {
      VALUE: isConsensusChecked ? "ON" : "OFF",
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras);
    // this.tempObj.values[0].values[0].selected = isConsensusChecked;

    this.setSelectionOnComputedSource("Consensus", isConsensusChecked);

    this.onValueUpdated();
  }

  consensusPlusChecked(isConsensusPlusChecked) {
    this.consensusPlusCheck = isConsensusPlusChecked;
    const feature = "OPTIONS_SOURCES_CONSENSUS+";
    const extras = {
      VALUE: isConsensusPlusChecked ? "ON" : "OFF",
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras);
    // this.tempObj.values[0].values[0].selected = isConsensusPlusChecked;
    this.setSelectionOnComputedSource("Consensus+", isConsensusPlusChecked);
    this.onValueUpdated();
  }

  filingsChecked(isFilingsChecked) {
    this.filingsCheck = isFilingsChecked;
    const feature = "OPTIONS_SOURCES_FILINGS";
    const extras = {
      VALUE: isFilingsChecked ? "ON" : "OFF",
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras);
    this.tempObj.values[1].values[1].selected = isFilingsChecked;
    this.onValueUpdated();
  }

  vaActualsChecked(isVaActualsChecked) {
    this.vaActualsCheck = isVaActualsChecked;
    const feature = "OPTIONS_SOURCES_VA ACTUALS";
    const extras = {
      VALUE: isVaActualsChecked ? "ON" : "OFF",
      URL: window.location.href,
      UTCTIME: this.appService.getCurrentUTCTime(),
    };
    this.logUserAction(feature, extras);
    this.tempObj.values[1].values[0].selected = isVaActualsChecked;
    this.onValueUpdated();
  }
  updateMEData(sourceData) {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    window.MEData.panels[panelIdx] =
      this.appService.getDuplicateObject(sourceData);
    window.MEData.panels[panelIdx].values[2].values.forEach((bro) => {
      if (this.showOnlyCurrent && bro.excluded) {
        bro.selected = false;
      }
    });
    this.setSourceRowColDimensions();
    // window.rightPanelChanges.panels[1] = window.MEData.panels[1];
  }

  setSourceRowColDimensions() {
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    const sourcesMEData = window.MEData.panels[panelIdx];
    const brokerList = sourcesMEData.values.find(
      (v) => v.name === "Brokers",
    ).values;
    const computedList = sourcesMEData.values.find(
      (v) => v.name === "computed",
    ).values;
    const histList = sourcesMEData.values.find(
      (v) => v.name === "Historicals",
    ).values;

    window.gSourceFuture = sourcesMEData["default-future"];
    window.gFocusSource = sourcesMEData["default-future"];
    window.gSourceActual = sourcesMEData["actual-default"];

    if (sourcesMEData.type === "row") {
      window.gSourceActual = window.gFocusSource;
    }

    const sourcesDimsCol: any = {
      name: "Sources",
      expansions: [
        [
          /* for historicals */
        ],
        [
          /* for forecast */
        ],
      ],
      values: [
        {
          /* for historicals */
        },
        {
          /* for forecast */
        },
      ],
    };

    const sourcesDimsRow: any = {
      name: "Sources",
      expansions: [
        /* list of selected sources other than forecast focus */
      ],
      values: [
        {
          /* source set to forecast focus */
        },
      ],
    };

    brokerList.forEach((source) => {
      if (source.name === sourcesMEData["actual-default"]) {
        sourcesDimsCol.values[0] = {
          name: source.name,
          expanded: false,
          validity: "actual",
        };
        sourcesDimsCol.expansions[1].push(source.name);

        sourcesDimsRow.expansions.push(source.name);
        return;
      }

      if (source.focus) {
        sourcesDimsCol.values[1] = {
          name: source.name,
          expanded: false,
          validity: "future",
        };
        sourcesDimsCol.expansions[0].push(source.name);

        sourcesDimsRow.values[0] = {
          name: source.name,
          expanded: false,
          validity: "future",
        };
        return;
      }

      if (source.selected) {
        sourcesDimsCol.expansions[0].push(source.name);
        sourcesDimsCol.expansions[1].push(source.name);

        sourcesDimsRow.expansions.push(source.name);
        return;
      }
    });

    histList.forEach((source) => {
      if (source.historical_focus) {
        sourcesDimsCol.values[0] = {
          name: source.name,
          expanded: false,
          validity: "actual",
        };

        sourcesDimsRow.expansions.push(source.name);
        return;
      }

      if (source.selected) {
        sourcesDimsCol.expansions[0].push(source.name);

        sourcesDimsRow.expansions.push(source.name);
        return;
      }
    });

    computedList.forEach((source) => {
      if (source.historical_focus) {
        sourcesDimsCol.values[0] = {
          name: source.name,
          expanded: false,
          validity: "actual",
        };
        sourcesDimsCol.expansions[1].push(source.name);

        sourcesDimsRow.expansions.push(source.name);
        return;
      }

      if (source.focus) {
        sourcesDimsCol.values[1] = {
          name: source.name,
          expanded: false,
          validity: "future",
        };
        sourcesDimsCol.expansions[0].push(source.name);

        sourcesDimsRow.values[0] = {
          name: source.name,
          expanded: false,
          validity: "future",
        };
        return;
      }

      if (source.selected) {
        sourcesDimsCol.expansions[0].push(source.name);
        sourcesDimsCol.expansions[1].push(source.name);

        sourcesDimsRow.expansions.push(source.name);
        return;
      }
    });

    this.removeSourceDimension();

    if (sourcesMEData.type === "row") {
      window.MEData.row_dimensions.push(sourcesDimsRow);
    } else if (sourcesMEData.type === "column") {
      window.MEData.column_dimensions.push(sourcesDimsCol);
    }
  }

  removeSourceDimension() {
    const sourceColIdx = window.MEData.column_dimensions.findIndex(
      (dimension) => dimension.name === "Sources",
    );

    const sourceRowIdx = window.MEData.row_dimensions.findIndex(
      (dimension) => dimension.name === "Sources",
    );

    if (sourceColIdx > 0) {
      window.MEData.column_dimensions.splice(sourceColIdx, 1);
    }

    if (sourceRowIdx > 0) {
      window.MEData.row_dimensions.splice(sourceRowIdx, 1);
    }
  }

  ngOnDestroy() {
    if (this.globalSettingsSub) {
      this.globalSettingsSub.unsubscribe();
    }
    if (this.navigationSettingSub) {
      this.navigationSettingSub.unsubscribe();
    }
    if (this.rightPanelSourcemetaSub) {
      this.rightPanelSourcemetaSub.unsubscribe();
    }
  }

  getIndexForPanel(panelsList) {
    return panelsList.findIndex(
      (panel) => panel.name.toLowerCase() === "sources",
    );
  }

  setCcState() {
    if (this.pageName.toLocaleLowerCase() !== "mex") {
      return;
    }
    const panelIdx = this.getIndexForPanel(window.MEData.panels);
    this.ccState = window.MEData.panels[panelIdx].values
      .find((stype) => stype.name === "computed")
      .values.find((s) => s.name === "Custom").selected;
  }
}
